export const navbarState = {
  heading: "My Teams",
  activeRoutePath: "",
  linkRoutes: [],
  dropDownRoutes: [],
};

export const navbarReducer = (state, action) => {
  switch (action.type) {
    case "setHeading":
      return { ...state, heading: action.value };
    case "setActiveRoutePath":
      return { ...state, activeRoutePath: action.value };
    case "setLinkRoutes":
      return { ...state, linkRoutes: action.value };
    case "setDropDownRoutes":
      return { ...state, dropDownRoutes: action.value };
    default:
      return state;
  }
};
